// extracted by mini-css-extract-plugin
module.exports = {"highlights":"Highlights-module--highlights--1N490","item":"Highlights-module--item--26fVF","num":"Highlights-module--num--1YQz0"};